import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HotelsPageRoutes } from './routes/routes.enum';
import { HotelListComponent } from './components/hotel-list/hotel-list.component';

export const routes: Routes = [
  {
    path: '',
    // component: HotelsPageComponent,
    // component: HotelListComponent,
    children: [
      {
        path: HotelsPageRoutes.List,
        loadChildren: () => import('./components/hotel-list/hotel-list.module').then(m => m.HotelListModule),
      },
      {
        path: HotelsPageRoutes.Hotel_Page,
        loadChildren: () => import('../hotels-pages/hotel-detail/hotel-detail.module').then(m => m.HotelDetailModule),
      },
      {
        path: HotelsPageRoutes.Room_Detail,
        loadChildren: () =>
          import("../hotels-pages/room-detail/room-detail.module").then(
            (m) => m.RoomDetailModule
          ),
      },
      {
        path: '**',
        // pathMatch: 'full',
        redirectTo: HotelsPageRoutes.List,
      },
    ] 
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class HotelsRoutingModule { }
